<template>
	<div
		:class="[
			'base-attention-box',
			size ? `base-attention-box--size-${size}` : '',
			background ? `base-attention-box--background-${background}` : '',
		]"
	>
		<i
			:class="['base-attention-box__icon', `base-attention-box__icon--${icon}`]"
		></i>
		<div class="base-attention-box__text">
			<div class="base-attention-box__text__title" v-if="$slots.title">
				<slot name="title"></slot>
			</div>
			<div
				class="base-attention-box__text__description"
				v-if="$slots.description"
			>
				<slot name="description"></slot>
			</div>
			<div class="base-attention-box__text__trigger" v-if="buttonText">
				<BaseButton variant="tertiary" :size="'none'" @click="handleClick">
					{{ buttonText }}
				</BaseButton>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed, type PropType } from 'vue'
import BaseButton from '@/components/ui/button/BaseButton.vue'

enum BaseAttentionBoxSize {
	Default = '',
	Medium = 'medium',
}

enum BaseAttentionBoxBackground {
	Default = '',
	Error = 'error',
}

enum BaseAttentionBoxIcon {
	Default = 'info',
	Error = 'error',
}

const props = defineProps({
	size: {
		type: String as PropType<`${BaseAttentionBoxSize}`>,
		default: BaseAttentionBoxSize.Default,
	},
	background: {
		type: String as PropType<`${BaseAttentionBoxBackground}`>,
		default: BaseAttentionBoxBackground.Default,
	},
	icon: {
		type: String as PropType<`${BaseAttentionBoxIcon}`>,
		default: BaseAttentionBoxIcon.Default,
	},
	buttonText: {
		type: String,
		default: '',
	},
})

const emit = defineEmits(['onClickButton'])

const buttonSize = computed(() =>
	props.size === BaseAttentionBoxSize.Default ? 'small' : props.size,
)

function handleClick() {
	emit('onClickButton')
}
</script>
